<template>
    <UiModal
        :is-open="showModal"
        title="Verify Phone Number"
        @close="closeModal()"
    >
        <template #content>
            <div class="flex w-full justify-center">
                <div class="prose">
                    <p class="mb-5">
                        We recently had an issue using your phone number to send
                        out an SMS message. Please visit your
                        <Link href="/settings">settings</Link>
                        and verify your phone number.
                    </p>
                </div>
            </div>
        </template>
        <template #footer>
            <div class="flex w-full gap-4 justify-end items-center">
                <button
                    type="button"
                    class="btn btn-primary"
                    @click="closeModal()"
                >
                    Close
                </button>

                <button
                    type="button"
                    class="btn btn-secondary"
                    @click="ignore()"
                >
                    Ignore this notice
                </button>
            </div>
        </template>
    </UiModal>
</template>

<script setup>
import UiModal from '@/components/ui/modal/ui-modal.vue';
import { Link } from '@inertiajs/vue3';

const props = defineProps({
    showModal: {
        type: Boolean,
        default: false,
    },
});

const emit = defineEmits(['close']);

const closeModal = () => {
    emit('close');
};

const ignore = () => {
    ApiService.apiCall('/user-settings/ignore-phone-invalid', 'get').then(
        () => {
            emit('close');
        }
    );
};
</script>
